import React from "react";

/**
 * Function to render the solution tube:
 *  Function doesn't properly work if split or used as component.
 */
export function drawTube(params) {
  const tubeList = [
    <path
      key="0"
      xmlns="http://www.w3.org/2000/svg"
      fill="#868ca6"
      d="M13.04 85.58C12.15 85.58 10.79 85.25 10.05 85.02C9.3 84.79 8.69 82.09 8.69 82.09C6.73 74.45 4.07 63.2 4.01 56.43C3.99 55.08 4.01 29 4.01 29L5.51 29L22.06 29L22.06 56.43C22.06 63.43 18.93 74.45 16.97 82.09C16.97 82.09 16.36 84.79 15.61 85.02C14.86 85.25 13.51 85.58 12.62 85.58"
    />,
    <path
      key="1"
      xmlns="http://www.w3.org/2000/svg"
      className="shp1"
      d="M12.99 84.64C12.19 84.64 10.97 84.36 10.32 84.13C9.67 83.94 9.1 81.47 9.1 81.47C7.33 74.63 5.52 64.53 5.01 58.52C5.01 55.43 5.01 32.62 5.01 32.62L5.01 30.43L21.05 30.43C21.05 30.43 21.34 55.35 21.05 58.52C20.54 64.53 18.32 74.58 16.54 81.43C16.54 81.43 15.98 83.85 15.33 84.08C14.67 84.27 13.45 84.59 12.66 84.59"
    />,
    <path
      key="2"
      xmlns="http://www.w3.org/2000/svg"
      fill="#868ca6"
      d="M2 29L25.07 29L25.07 31L2 31L2 29Z"
    />,
  ];

  if (params.solutionColor && params.pelletColor) {
    tubeList.push(
      <path
        key="3"
        xmlns="http://www.w3.org/2000/svg"
        opacity="0.7"
        d="M12.9865 84.6415C12.1913 84.6415 10.975 84.3619 10.3201 84.129C9.66523 83.9427 9.10388 81.4735 9.10388 81.4735C7.3263 74.6252 5.52335 64.5288 5.00879 58.519V45H13.5002H21.0545V48.519C20.54 64.5288 18.3192 74.5786 16.5417 81.4269C16.5417 81.4269 15.9803 83.8495 15.3254 84.0824C14.6705 84.2688 13.4543 84.5949 12.659 84.5949"
        fill={params.solutionColor}
      />
    );
  } else if (params.solutionColor) {
    tubeList.push(
      <path
        key="4"
        xmlns="http://www.w3.org/2000/svg"
        opacity="0.7"
        d="M12.9865 84.6415C12.1913 84.6415 10.975 84.3619 10.3201 84.129C9.66523 83.9427 9.10388 81.4735 9.10388 81.4735C7.3263 74.6252 5.52335 64.5288 5.00879 58.519V55H13.5002H21.0545V58.519C20.54 64.5288 18.3192 74.5786 16.5417 81.4269C16.5417 81.4269 15.9803 83.8495 15.3254 84.0824C14.6705 84.2688 13.4543 84.5949 12.659 84.5949"
        fill={params.solutionColor}
      />
    );
  }

  if (params.pelletColor) {
    tubeList.push(
      <path
        key="5"
        opacity="0.7"
        d="m17.68754,76.6787l-9.73461,-0.04004c0.00049,0.00879 1.31295,5.43053 1.31247,5.42174c0.00049,0.00879 0.29736,0.96189 0.29687,0.9531c0.00049,0.00879 0.37548,0.80565 0.37499,0.79685c0.00049,0.00879 0.21923,0.22754 0.21874,0.21874c0.00049,0.00879 0.5786,0.22754 0.57811,0.21874c0.00049,0.00879 1.96919,0.44628 1.9687,0.43749c0.00049,0.00879 2.6098,-0.58494 2.60931,-0.59373c0.00049,0.00879 0.34423,-0.25683 0.34374,-0.26562c0.00049,0.00879 0.32861,-0.61619 0.32812,-0.62498c0.00049,0.00879 0.3911,-1.08493 0.39061,-1.09372c0.00049,0.00879 1.32858,-5.27232 1.32809,-5.28111"
        fill={params.pelletColor}
      />
    );
  }

  if (params.circleColor || params.label || params.circleColor) {
    const bannerColor = params.bannerColor || "#ffffff";
    tubeList.push(
      <path key="6" fill={bannerColor} d="M3.5 35 H21.8 V52 H3.5 z"></path>
    );
  }

  if (params.circleOutline) {
    tubeList.push(
      <circle
        key="7"
        cx="12.45"
        cy="43.5"
        r="6"
        fill={params.circleOutline}
      ></circle>
    );
  }

  if (params.circleColor) {
    tubeList.push(
      <circle
        key="8"
        cx="12.45"
        cy="43.5"
        r="4.5"
        fill={params.circleColor}
      ></circle>
    );
  }

  if (params.label) {
    tubeList.push(
      <text
        key="9"
        x="13"
        y="45"
        z="1000"
        fill="#000"
        fontSize="8.0px"
        fontFamily="sans-serif"
        alignmentBaseline="middle"
        textAnchor="middle"
        className="tubeSVG__label"
      >
        {params.label}
      </text>
    );
  }

  tubeList.push(
    <path
      key="10"
      xmlns="http://www.w3.org/2000/svg"
      opacity="0.102"
      fill="#000000"
      d="M17.04 31L22.06 31C22.06 31 22.06 54.56 22.06 57.51C22.06 60.45 20.05 69.78 20.05 69.78C20.05 69.78 16.26 84.29 16.04 84.51C15.82 84.72 13.03 85 13.03 85L17.04 57.51L17.04 31Z"
    />
  );

  if (params.isOpen) {
    tubeList.push(
      <rect
        key="11"
        xmlns="http://www.w3.org/2000/svg"
        x="35.251"
        y="6.47754"
        width="16"
        height="3.6703"
        fill="#AFB3C5"
        opacity="0.5"
        transform="rotate(108.892 35.251 6.47754)"
      />,
      <path
        key="12"
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4982 27.0635L38.854 2.64758L36.9617 2L28.5432 26.5994L28.5761 26.6106C28.1739 27.3836 27.5439 27.9824 26.8605 28.3925C26.1473 28.8204 25.4483 29 25 29V31C25.885 31 26.936 30.6796 27.8895 30.1075C28.8558 29.5277 29.7949 28.6462 30.3944 27.4472C30.4562 27.3236 30.49 27.1933 30.4982 27.0635Z"
        fill="#868CA6"
      />
    );
  } else {
    tubeList.push(
      <path
        key="13"
        className="shp5"
        d="M5.01 28L21.05 28L21.05 29L5.01 29L5.01 28Z"
      />,
      <path
        key="14"
        fillRule="evenodd"
        fill="#868ca6"
        d="M27.75 27.12C28 27.55 28.08 28.03 28.08 28.5C28.08 28.97 28 29.45 27.75 29.88C27.48 30.32 27.09 30.59 26.67 30.75C26.28 30.89 25.85 30.95 25.44 30.97C25.04 31 24.57 31 24.09 31L24.07 31L24.07 29C24.58 29 24.98 29 25.32 28.98C25.66 28.96 25.86 28.92 25.97 28.88C25.99 28.87 26.01 28.86 26.02 28.85C26.02 28.85 26.02 28.85 26.03 28.85C26.03 28.85 26.03 28.84 26.03 28.84C26.03 28.83 26.04 28.81 26.05 28.78C26.06 28.72 26.07 28.63 26.07 28.5C26.07 28.37 26.06 28.28 26.05 28.22C26.04 28.19 26.03 28.17 26.03 28.16C26.03 28.16 26.03 28.15 26.03 28.15C26.02 28.15 26.02 28.15 26.02 28.15C26.01 28.14 25.99 28.13 25.97 28.12C25.86 28.08 25.66 28.04 25.32 28.02C24.98 28 24.58 28 24.07 28L24.07 26L24.09 26C24.57 26 25.04 26 25.44 26.03C25.85 26.05 26.28 26.11 26.67 26.25C27.09 26.41 27.48 26.68 27.75 27.12Z"
      />,
      <path key="15" fill="#868ca6" d="M1 26L25 26L25 28L1 28L1 26Z" />
    );
  }

  return (
    <svg
      role="img"
      aria-label={params.title}
      xmlns="http://www.w3.org/2000/svg"
      width="39"
      height="86"
      viewBox="0 0 39 86"
      fill="none"
    >
      {tubeList}
    </svg>
  );
}

/**
 * Function to set the size scale of SolutionTube
 */
const SIZE_SCALE_CHART = {
  sm: 0.85,
  md: 1.0,
  lg: 1.15,
};
export function getScale(size = "md") {
  return { transform: `scale(${SIZE_SCALE_CHART[size]})` };
}
